module.exports = __webpack_public_path__ + "static/media/inq.cc0eaf25.png";